
import React from 'react';
import BeforeAfterShowcase from './BeforeAfterShowcase';

const QualityWorkSection = () => {
  return (
    <section className="section bg-lightgray py-8 md:py-10">
      <div className="container-custom">
        <div className="text-center mb-6">
          <h2 className="mb-2">Our Quality Work</h2>
          <p className="max-w-2xl mx-auto text-navy/80 text-sm md:text-base">
            See the difference our professional electrical services make with our before and after transformations.
          </p>
        </div>
        
        <BeforeAfterShowcase />
      </div>
    </section>
  );
};

export default QualityWorkSection;
